import { useEffect, useState } from 'react';

/**
 * Tracks `navigator.onLine` via the browser's `online`/`offline` events.
 * Extracted out of `PosStatusChip` (which had this exact six-line pattern
 * inline, the only place it existed) so `ConnectivityIndicator` and
 * `SyncActivityIndicator` share the one listener instead of each rolling
 * their own copy - matching this project's "reuse existing mechanisms
 * rather than inventing parallel ones" discipline.
 */
export function useOnlineStatus(): boolean {
  const [online, setOnline] = useState(() => navigator.onLine);

  useEffect(() => {
    const up = () => setOnline(true);
    const down = () => setOnline(false);
    window.addEventListener('online', up);
    window.addEventListener('offline', down);
    return () => {
      window.removeEventListener('online', up);
      window.removeEventListener('offline', down);
    };
  }, []);

  return online;
}
